import { cardsItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/60 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-article-line text-sm"></i>
            图文资讯
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">更多热门爆料</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">最新最热的娱乐爆料图文资讯，每天更新，精彩不断。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsItems.slice(0, 6).map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200/70 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">{item.summary}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}阅读
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {cardsItems.length > 6 && (
          <div className="mt-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {cardsItems.slice(6).map((item) => (
                <a
                  key={item.id}
                  href="#cards"
                  className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200/70 transition-colors duration-300 cursor-pointer"
                >
                  <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded whitespace-nowrap">{item.tag}</span>
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">{item.summary}</p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{item.time}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {item.views}阅读
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}